/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_Moment_TitleInputs */

const en_us2_today_moment_title = /** @type {(inputs: Today_Moment_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last week in numbers`)
};

const pt_br2_today_moment_title = /** @type {(inputs: Today_Moment_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua semana passada em números`)
};

const es_419_today_moment_title = /** @type {(inputs: Today_Moment_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu semana pasada en números`)
};

const pt_pt2_today_moment_title = /** @type {(inputs: Today_Moment_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tua semana passada em números`)
};

const fr_fr2_today_moment_title = /** @type {(inputs: Today_Moment_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta semaine dernière en chiffres`)
};

const de_de2_today_moment_title = /** @type {(inputs: Today_Moment_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine letzte Woche in Zahlen`)
};

const it_it2_today_moment_title = /** @type {(inputs: Today_Moment_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua settimana scorsa in numeri`)
};

/**
* | output |
* | --- |
* | "Last week in numbers" |
*
* @param {Today_Moment_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_moment_title = /** @type {((inputs?: Today_Moment_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Moment_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_moment_title(inputs)
	if (locale === "es-419") return es_419_today_moment_title(inputs)
	if (locale === "pt-PT") return pt_pt2_today_moment_title(inputs)
	if (locale === "fr-FR") return fr_fr2_today_moment_title(inputs)
	if (locale === "de-DE") return de_de2_today_moment_title(inputs)
	if (locale === "it-IT") return it_it2_today_moment_title(inputs)
	return en_us2_today_moment_title(inputs)
});
export { today_moment_title as "today.moment_title" }